import React, { use } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from '@components-clean/core/card';
import { CTQFactorsContext } from '@pages-clean/risk-assessment/interfaces/context';
import { useTranslation } from '@hooks/index';
import './index.scss';

const CriticalToQualityDetail = () => {
    const { t } = useTranslation('ram', { keyPrefix: 'ctqf.ctqDetails' });
    const { current } = use(CTQFactorsContext);
    const ctqDetails = current.selectionState.selectedItem;

    const criticalColourClass = ctqDetails?.isCritical ? 'icon-critical-color' : 'icon-default-color';
    const activeColourClass = ctqDetails?.active ? 'icon-active-color' : 'icon-default-color';

    return (
        <Card
            title={t('ctqDetails')}
            data-testid="ctqf-detail-section"
            className="ctq-detail"
            bodyClassName="ctq-detail-splitters"
        >
            <div className="body">
                <div className="critical-active-body">
                    <div className="critical-active-section">
                        <FontAwesomeIcon
                            icon={['far', 'square-exclamation']}
                            className={`icon-styling ${criticalColourClass}`}
                        />
                        <div className="critical-active-title k-pl-3">
                            {ctqDetails?.isCritical ? t('critical') : t('notCritical')}
                        </div>
                    </div>
                    <div className="critical-active-section">
                        <FontAwesomeIcon
                            icon={ctqDetails?.active ? ['far', 'circle-check'] : ['far', 'do-not-enter']}
                            className={`icon-styling ${activeColourClass}`}
                        />
                        <div className="critical-active-title k-pl-3">
                            {ctqDetails?.active ? t('active') : t('inactive')}
                        </div>
                    </div>
                </div>
                <div>
                    <div className="description-justification-title">{t('ctqDetailsDescription')}</div>
                    <div className="description-justification-textarea description-textarea-margin">
                        {ctqDetails?.description || ''}
                    </div>
                </div>
                <div>
                    <div className="description-justification-title">{t('ctqDetailsJustification')}</div>
                    <div className="description-justification-textarea">{ctqDetails?.justification || ''}</div>
                </div>
            </div>
        </Card>
    );
};

export default CriticalToQualityDetail;
